import { render } from "./employee-dashboard.vue?vue&type=template&id=0fc34d50&scoped=true"
import script from "./employee-dashboard.vue?vue&type=script&lang=js"
export * from "./employee-dashboard.vue?vue&type=script&lang=js"

import "./employee-dashboard.vue?vue&type=style&index=0&id=0fc34d50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc34d50"]])

export default __exports__